module.exports = __webpack_public_path__ + "img/pano_3.a2161349.jpg";